<template>
    <div>
        <e-dialog
                dialogType="other"
                dialog-title="选择标签附件"
                :center-dialog-visible="labelVisible"
                popup-width="420px"
                @submitPopupData="submitPopupData"
                @resetPopupData="handleClose">
            <el-form :model="formData" label-width="96px">
                <el-form-item label="请选择标签：" style="margin-bottom: 14px">
                    <div class="flex" style="flex-wrap: wrap">
                        <div v-for="(item,index) in labelData" :key="index" class="label-box margin-r20"
                             style="cursor: pointer"
                             :class="[chooseLabel === item.name ? 'label-gray' : '']">
                            <div @click="chooseItem(item.name)">{{item.name}}</div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="已选标签：" style="margin-bottom: 0">
                    <eui-btn type="secondary" icon="eicon-close" @click="chooseLabel = ''" v-if="chooseLabel">
                        {{chooseLabel}}
                    </eui-btn>
                    <div v-else style="height: 30px;"></div>
                </el-form-item>
            </el-form>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
export default {
  name: 'labelDialog',
  components: {
    eDialog
  },
  props: {
    labelVisible: Boolean,
    chooseLabelParent: String
  },
  data() {
    return {
      formData: {},
      labelData: [
        {name: '质检报告'},
        {name: '检验证明'},
        {name: '质量文件'},
        {name: '采购说明'},
        {name: '合同文件'},
        {name: '其他'},
      ],
      chooseLabel: '',
    }
  },
  methods: {
    chooseItem(name) {
      this.chooseLabel = name;
    },
    submitPopupData() {
      if (!this.chooseLabel) {
        this.$message.warning('请选择附件标签。');
        return false;
      }
      this.$emit('confirmLabel', this.chooseLabel);
      this.handleClose();
    },
    handleClose() {
      this.$emit('update:labelVisible', false);
    },
  },
  watch: {
    'chooseLabelParent': {
      handler(val) {
        this.chooseLabel = val;
      },
      immediate: true,
      deep: true,
    },
  },

};
</script>

<style lang="scss" scoped>
    .label-box {
        display: inline-block;
        cursor: pointer;
        border-bottom: 1px solid transparent;

        &:hover {
            color: #004898;
            border-bottom: 1px solid #004898;
        }
    }

    .label-gray {
        color: #999;

        &:hover {
            color: #999;
            border-bottom: none;
        }
    }
    ::v-deep .el-form-item__content {
        line-height: 24px;
    }

    ::v-deep .el-form-item__label {
        line-height: 24px;
        color: #333;
    }

    ::v-deep .el-dialog__body {
        color: #333;
    }


</style>
